var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M6 0a6 6 0 014.891 9.476L15.414 14 14 15.414l-4.524-4.523A6 6 0 116 0zm0 2a4 4 0 100 8 4 4 0 000-8z"})));
}

SearchInline.defaultProps = {"width":"16","height":"16"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
